/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AmazonBehavioralHealthScreeningResponse } from './AmazonBehavioralHealthScreeningResponse';
import type { JsonNode } from './JsonNode';
import type { PrescriptionLabelUploadResponse } from './PrescriptionLabelUploadResponse';
import type { TaskBehaviorResponse } from './TaskBehaviorResponse';
import type { TaskUiElementsCoachingCallRatingResponse } from './TaskUiElementsCoachingCallRatingResponse';
import type { TaskUiElementsGlp1Response } from './TaskUiElementsGlp1Response';
import type { TaskUiElementsGlp1StartDateResponse } from './TaskUiElementsGlp1StartDateResponse';
import type { TaskUiElementsLabsResponse } from './TaskUiElementsLabsResponse';
import type { TaskUiElementsQuestionnaireResponse } from './TaskUiElementsQuestionnaireResponse';
import type { TaskUiElementsResponse } from './TaskUiElementsResponse';
import type { TaskUiElementsSchedulingResponse } from './TaskUiElementsSchedulingResponse';
import type { TaskUiElementsSyncVisitResponse } from './TaskUiElementsSyncVisitResponse';
import type { TaskUiElementsWaistMeasurementResponse } from './TaskUiElementsWaistMeasurementResponse';
import type { WeightProofUploadResponse } from './WeightProofUploadResponse';

/**
 * Describes a single task item.
 */
export type TaskResponse = {
    /**
     * Identifies the task for REST operations. Can be absent if the task is transient and cannot be directly modified.
     */
    id?: string;
    /**
     * The current status of this task.
     */
    status: TaskResponse.status;
    /**
     * An identifier for the program that this task belongs to.
     */
    program: string;
    /**
     * An identifier for the group that this task belongs to (inside the program).
     */
    group: string;
    /**
     * An identifier for the task itself (inside the group).
     */
    slug: string;
    /**
     * The date/time when this task was created.
     */
    createdAt: string;
    /**
     * The date/time when this task was last updated.
     */
    updatedAt: string;
    /**
     * The date/time when this task will become available.
     */
    availableFrom?: string;
    /**
     * The date/time when this task will no longer be available.
     */
    availableTo?: string;
    /**
     * The date/time when this task was started.
     */
    startedAt?: string;
    /**
     * The date/time when this task was completed.
     */
    completedAt?: string;
    /**
     * Additional data about the task
     */
    additionalData: JsonNode;
    /**
     * UI elements for this task, such as title and icon type.
     */
    uiElements: (TaskUiElementsResponse | AmazonBehavioralHealthScreeningResponse | PrescriptionLabelUploadResponse | TaskUiElementsCoachingCallRatingResponse | TaskUiElementsGlp1Response | TaskUiElementsGlp1StartDateResponse | TaskUiElementsLabsResponse | TaskUiElementsQuestionnaireResponse | TaskUiElementsSchedulingResponse | TaskUiElementsSyncVisitResponse | TaskUiElementsWaistMeasurementResponse | WeightProofUploadResponse);
    /**
     * Describes the behavior of a task, such as whether it can be skipped or completed by the user or care team.
     */
    behavior: TaskBehaviorResponse;
};

export namespace TaskResponse {

    /**
     * The current status of this task.
     */
    export enum status {
        LOCKED = 'LOCKED',
        AVAILABLE = 'AVAILABLE',
        IN_PROGRESS = 'IN_PROGRESS',
        COMPLETED = 'COMPLETED',
        SKIPPED = 'SKIPPED',
    }


}

